import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/171/components/features/cases/OldComponents/cases/upgreat/index.js");
